var map = {
	"./Marker_blue.png": "595d",
	"./Marker_green.png": "531e",
	"./Marker_lightblue.png": "bb41",
	"./Marker_lightgreen.png": "b357",
	"./Marker_orange.png": "ce4e",
	"./Marker_purple.png": "7546",
	"./Marker_red.png": "e324",
	"./Marker_yellow.png": "e4e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4807";